import { NgModule } from '@angular/core';
import { ConfigsApplication } from './service/configs.application';
import { SystemConfigInfructureLayerModule } from '../infrustructure/system-config-infrustructre.module';
import { SystemConfigDomainLayerModule } from '../domain/system-config-domain.module';

@NgModule({
  providers: [ConfigsApplication],
  imports: [SystemConfigInfructureLayerModule, SystemConfigDomainLayerModule],
  exports: [],
})
export class SystemConfigApplicationModule {}
